import { get } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { APP_CONFIG } from '@/config';
import { UpsellPurchaseResponse } from '@/@types/upsell';

export const getUpsellPurchaseResult = async (transactionId: string) => {
  return await get<UpsellPurchaseResponse>(
    `${APP_CONFIG.baseApiUrl}${ApiEndpoints.upsellPurchaseResult(transactionId)}`,
  );
};
